import { lazy } from 'react';

const Agents = lazy(() => import('./AdminAgentsPage'));

const AdminAgentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/agents',
      element: <Agents />,
    },
  ],
};

export default AdminAgentsConfig;
